import { FiHome, FiUsers, FiDollarSign, FiSearch } from 'react-icons/fi'

// `match`: rutas que marcan la opción como activa en el menú.
export const LinkItems = [
  {
    name: 'Escritorio',
    icon: FiHome,
    link: '/plataforma/asesoras',
    match: ['/plataforma/asesoras/ver-prospecto', '/plataforma/asesoras/prospectos'],
  },
  {
    name: 'Consultar Estudiante',
    icon: FiSearch,
    link: '/plataforma/asesoras/consultar-estudiante',
    match: ['/plataforma/asesoras/ver-estudiante'],
  },
  {
    name: 'Registrados',
    icon: FiUsers,
    link: '/plataforma/asesoras/estudiantes-registrados',
  },

  {
    name: 'Nuevos estudiantes',
    icon: FiDollarSign,
    link: '/plataforma/asesoras/nuevos-estudiantes',
  },
  {
    name: 'Prospectos Landing',
    icon: FiUsers,
    link: '/plataforma/asesoras/prospectos-landing',
  },
  {
    name: 'Comisiones',
    icon: FiDollarSign,
    link: '/plataforma/asesoras/comisiones',
  },
]

export const isLinkActive = (item, pathname) => {
  const path = pathname.replace(/\/$/, '')
  if (path === item.link) return true
  return (item.match || []).some((prefix) => path.startsWith(prefix))
}
